import axios from '../utils/axios';
import config from '../utils/config';

const BLS_LIST = config.get('bls_api', 'bls_list');
const BLS_QUESTION_TYPES = config.get('bls_api', 'question_types');
const BLS_STUDY_SUBMIT = config.get('bls_api', 'submit_study');
const BLS_STUDY_DETAILS = config.get('bls_api', 'view_study_details');
export const BLS_UPLOD_EXCEL = config.get('bls_api', 'upload_excel');

async function getBlsList(accessToken, username, accountId, recordsPerPage, page, searchKeyword) {
    let url = config.formUrl(BLS_LIST, accountId) + `?recordsPerPage=${recordsPerPage}&page=${page}`;
    if (searchKeyword) {
      url = url + `&searchFields=studyName,studyId&searchText=${searchKeyword}`;
    }
    try {
      const list = await axios({
        method: 'get',
        responseType: 'json',
        url: url,
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return list;
    } catch (error) {
      throw error.response;
    }
  }

  async function getBlsQuestionTypes(accessToken, username) {
    try {
      const list = await axios({
        method: 'get',
        responseType: 'json',
        url: config.formUrl(BLS_QUESTION_TYPES),
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return list;
    } catch (error) {
      throw error.response;
    }
  }

  async function onStudySubmit(accessToken, username, data) {
    try {
      const submitRes = await axios({
        method: 'post',
        responseType: 'json',
        url: BLS_STUDY_SUBMIT,
        data: data,
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return submitRes;
    } catch (error) {
      throw error.response;
    }
  }

  async function getStudyDetails(accessToken, username, studyId) {
    try {
      const list = await axios({
        method: 'get',
        responseType: 'json',
        url: config.formUrl(BLS_STUDY_DETAILS, studyId),
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return list;
    } catch (error) {
      throw error.response;
    }
  } 


  export {
    getBlsList,
    getBlsQuestionTypes,
    onStudySubmit,
    getStudyDetails
  }